import { Component, EventEmitter, Input, model, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SalesManagerModalComponent } from '../../core/modals/sales-manager-modal/sales-manager-modal.component';
import { DetailsPanelService } from './details-panel.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { FollowUpComponent } from '../../core/modals/follow-up/follow-up.component';
import { LostJunkComponent } from '../../core/modals/lost-junk/lost-junk.component';
import { NoResponseComponent } from '../../core/modals/no-response/no-response.component';
import { NonSalesComponent } from '../../core/modals/non-sales/non-sales.component';
import { LeadHistoryComponent } from '../lead-history/lead-history.component';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';
import { environment } from '../../../environments/environment';
import { SharedService } from '../shared.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

interface LeadDetails {
  name: string;
  email: string;
  alternate_mobile: string;
  alternate_email: string;
  product_details: {
    product_category: string;
    product_model: string;
  };
  current_stage: {
    stage_id: number;
    next_followup_date: string;
    next_followup_time: string;
  };
  _id: string;
}

interface UpdatePayload {
  first_name: string;
  middle_name: string;
  last_name: string;
  email: string;
  alternate_mobile: string;
  alternate_email: string;
  product_category: string;
  product_model: string;
  product_variant: string;
  product_color: string;
  next_followup_date?: string;
  next_followup_time?: string;
  followup_reason?: string;
  junk_reason?: string;
  lost_reason?: string;
  customer_interest?: string;
  finance?: string;
  age_group?: string;
}


@Component({
  selector: 'app-details-panel',
  templateUrl: './details-panel.component.html',
  styleUrls: ['./details-panel.component.scss']
})
export class DetailsPanelComponent implements OnInit {
  bucketurl = environment.bucketUrl;
  leadDetails: any = {};
  originalLeadDetails: any = {};
  isEditMode = false;
  masters: any = [];
  categories: any = [];
  products: any = [];
  variants: any = [];
  prodColors: any = [];
  followUpReason: any = [];
  preSalesLostReason: any = [];
  filteredProducts: any = [];
  filteredProductsColorId: any = [];
  filteredProductsVar: any = [];
  filteredProductsVarColorId: any = [];
  filteredProductsColor: any = [];
  junkReason: any = [];
  isLoading: Subject<boolean> = new Subject<boolean>();
  customerInterest: any = [];
  financeList: any = [];
  ageGroupList: any = [];
  @Output() change = new EventEmitter<boolean>();
  selectedProductId: any;
  uniqueColorIds: any = [];
  productForm!: FormGroup
  constructor(private fb: FormBuilder, private sharedService: SharedService, public dialog: MatDialog, private detailsPanelService: DetailsPanelService, private toastr: ToastrService,) {
    this.productForm = this.fb.group({
      category: ['', Validators.required],
      model: ['', Validators.required],
      variant: ['', Validators.required],
      color: ['', Validators.required],
      first_name: ['', Validators.required],
      age_group: ['', Validators.required],
      customer_interest: ['', Validators.required],
    })

  }

  get f() {
    return this.productForm.controls;
  }
  submitted: boolean = false;
  ngOnInit() {
    const masters = JSON.parse(sessionStorage.getItem('masters') || '{}');
    if (masters) {
      this.masters = masters;
      this.categories = this.masters.productCategories || [];
      // console.log(this.categories);

      this.products = this.masters.productModel || [];
      // console.log(this.products, 'products');

      this.variants = this.masters.productVariant;
      // console.log(this.variants, 'variants');
      this.prodColors = this.masters.productColor;
      // console.log(this.prodColors);


      this.followUpReason = this.masters.followUpReason || [];
      this.preSalesLostReason = this.masters.preSalesLostReason || [];
      this.junkReason = this.masters.junkReason || [];
      this.customerInterest = this.masters.customerInterests ? this.masters.customerInterests : []
      this.financeList = this.masters.finance ? this.masters.finance : []
      this.ageGroupList = this.masters.ageGroup ? this.masters.ageGroup : []
    }
  }

  editDetails() {
    // Copy the current lead details to preserve the original state
    this.originalLeadDetails = { ...this.leadDetails };
    // console.log(this.originalLeadDetails, 'this.originalLeadDetails');


    let prodId: any = this.originalLeadDetails?.product_details?.product_category_id ? this.originalLeadDetails?.product_details?.product_category_id + ":" + this.originalLeadDetails?.product_details?.product_category : ''
    let prodModel: any = this.originalLeadDetails?.product_details?.product_model_id ? this.originalLeadDetails?.product_details?.product_model_id + ":" + this.originalLeadDetails?.product_details?.product_model + ' - ' + this.originalLeadDetails?.product_details?.product_model_code : ''
    let prodVar: any = this.originalLeadDetails?.product_details?.product_variant_id ? this.originalLeadDetails?.product_details?.product_variant_id + ":" + this.originalLeadDetails?.product_details?.product_variant + ' - ' + this.originalLeadDetails?.product_details?.product_variant_code : ''
    let prodColor: any = this.originalLeadDetails?.product_details?.product_color_id ? this.originalLeadDetails?.product_details?.product_color_id + ":" + this.originalLeadDetails?.product_details?.product_color + ' - ' + this.originalLeadDetails?.product_details?.product_color_code : ''


    this.originalLeadDetails.prodId = prodId ? prodId : '';
    this.originalLeadDetails.prodModel = prodModel ? prodModel : '';
    this.originalLeadDetails.prodVar = prodVar ? prodVar : '';
    this.originalLeadDetails.prodColor = prodColor ? prodColor : '';


    let customerInterestId: any = this.originalLeadDetails?.current_stage?.customer_interest_id ? this.originalLeadDetails?.current_stage?.customer_interest_id + ":" + this.originalLeadDetails?.current_stage?.customer_interest : ''
    this.originalLeadDetails.customerInterestId = customerInterestId ? customerInterestId : '';

    let financeId: any = this.originalLeadDetails?.finance_id ? this.originalLeadDetails?.finance_id + ":" + this.originalLeadDetails?.finance : ''
    this.originalLeadDetails.financeId = financeId ? financeId : '';

    let ageGroupId: any = this.originalLeadDetails?.age_group_id ? this.originalLeadDetails?.age_group_id + ":" + this.originalLeadDetails?.age_group : ''
    this.originalLeadDetails.ageGroupId = ageGroupId ? ageGroupId : '';

    // Handle next_followup_date and next_followup_time
    if (this.leadDetails.current_stage.stage_id === 2) {
      this.originalLeadDetails.next_followup_date = this.formatDateForInput(
        this.leadDetails.current_stage.next_followup_date,
        'YYYY-MM-DD'
      );
      this.originalLeadDetails.next_followup_time = this.leadDetails.current_stage.next_followup_date ? new Date(this.leadDetails.current_stage.next_followup_date) : null;

      const selectedReasonId = this.originalLeadDetails.current_stage.followup_reason_id;
      if (selectedReasonId) {
        const selectedReason = this.followUpReason.find((reason: any) => reason.id === selectedReasonId);
        if (selectedReason) {
          this.originalLeadDetails.followup_reason = selectedReason.id + ':' + selectedReason.reason;
        }
      }
    }
    if (this.leadDetails.current_stage.stage_id === 5) {
      const selectedJunkReasonId = this.originalLeadDetails.current_stage.junk_reason_id;
      if (selectedJunkReasonId) {
        const selectedJunkReason = this.junkReason.find((reason: any) => reason.id === selectedJunkReasonId);
        if (selectedJunkReason) {
          this.originalLeadDetails.junk_reason = selectedJunkReason.id + ':' + selectedJunkReason.reason;
        }
      }
    }
    if (this.leadDetails.current_stage.stage_id === 7) {
      const selectedLostReasonId = this.originalLeadDetails.current_stage.lost_reason_id;
      if (selectedLostReasonId) {
        const selectedLostReason = this.preSalesLostReason.find((reason: any) => reason.id === selectedLostReasonId);
        if (selectedLostReason) {
          this.originalLeadDetails.lost_reason = selectedLostReason.id + ':' + selectedLostReason.reason;
        }
      }
    }
    const categoryId = this.originalLeadDetails.prodId.split(':')[0];
    if (categoryId) {
      this.filteredProducts = this.products.filter((product: any) => product.category_id === parseInt(categoryId));
      // console.log(this.filteredProducts, 'this.filteredProducts');

    } else {
      this.filteredProducts = [];
    }
    const modelId = this.originalLeadDetails.prodModel.split(':')[0];
    if (modelId) {
      this.filteredProductsVar = this.variants.filter((variant: any) => variant.model_id == modelId);

      // console.log(this.filteredProductsVar, 'filteredProductsVar');
    }
    const variantId = this.originalLeadDetails.prodVar.split(':')[0];
    this.filteredProductsColorId = this.variants.find((variant: any) => variant.id == variantId)
    console.log(this.filteredProductsColorId, 'this.filteredProductsColorId');
    if (this.filteredProductsColorId?.color_id && this.filteredProductsColorId?.color_id.length > 0) {
      const allColorIds: any = this.filteredProductsColorId?.color_id.map((id: any) => parseInt(id));

      // console.log(this.uniqueColorIds, 'Unique Color IDs');

      this.filteredProductsColor = this.prodColors.filter((color: any) =>
        allColorIds.includes(color.id)
      );
    }
    this.isEditMode = true;
    const updatedValues = {
      category: this.originalLeadDetails?.product_details?.product_category_id ? this.originalLeadDetails.prodId : '',
      model: this.originalLeadDetails?.product_details?.product_model_id ? this.originalLeadDetails.prodModel : '',
      variant: this.originalLeadDetails?.product_details?.product_variant_id ? this.originalLeadDetails.prodVar : '',
      color: this.originalLeadDetails?.product_details?.product_color_id ? this.originalLeadDetails.prodColor : '',
    };

    console.log("Updated Form Values:", updatedValues);
    setTimeout(() => {
      this.productForm.patchValue({
        category: this.originalLeadDetails?.product_details?.product_category_id ? this.originalLeadDetails.prodId : '',
        model: this.originalLeadDetails?.product_details?.product_model_id ? this.originalLeadDetails.prodModel : '',
        variant: this.originalLeadDetails?.product_details?.product_variant_id ? this.originalLeadDetails.prodVar : '',
        color: this.originalLeadDetails?.product_details?.product_color_id ? this.originalLeadDetails.prodColor : '',
        first_name: this.originalLeadDetails?.first_name ? this.originalLeadDetails?.first_name : '',
        age_group: this.originalLeadDetails?.ageGroupId ? this.originalLeadDetails?.ageGroupId : '',
        customer_interest: this.originalLeadDetails?.customerInterestId ? this.originalLeadDetails?.customerInterestId : '',
      })
    }, 2000)
  }

  cancelEdit() {
    this.isFieldEdited = false;
    // Restore original details and exit edit mode
    this.leadDetails = { ...this.originalLeadDetails };
    this.isEditMode = false;
    // Reset product category and product model dropdowns if needed
    this.filteredProducts = []; // Reset filtered products
    this.filteredProductsVar = [];
    this.filteredProductsColor = [];
  }

  saveDetails() {
    // Create a new object with fields to update
    this.submitted = true;
    if (!this.productForm.valid) {
      return;
    }
    if (this.emailError) {
      this.toastr.error("Email is invalid!")
    } else if (this.alternateEmailError) {
      this.toastr.error("Alternate email is invalid!")
    } else if (this.mobileNumberError) {
      this.toastr.error("Enter a valid 10-digit alternate number!")
    } else {
      const updatePayload: UpdatePayload = {
        first_name: this.productForm.value.first_name,
        middle_name:this.leadDetails.middle_name ? this.leadDetails.middle_name : null,
        last_name: this.leadDetails.last_name ? this.leadDetails.last_name : null,
        email: this.leadDetails.email,
        alternate_mobile: this.leadDetails.alternate_mobile ? this.leadDetails.alternate_mobile : null,
        alternate_email: this.leadDetails.alternate_email ? this.leadDetails.alternate_email : null,
        product_category: this.productForm.value.category,
        product_model: this.productForm.value.model,
        product_variant: this.productForm.value.variant ? this.productForm.value.variant : '',
        product_color: this.productForm.value.color ? this.productForm.value.color : '',
        customer_interest: this.productForm.value.customer_interest,
        finance: this.originalLeadDetails.financeId,
        age_group: this.productForm.value.age_group
      };
      if (this.leadDetails.alternate_mobile == this.leadDetails.mobile) {
        this.toastr.error("Alternate number cannot be same as Phone number!")
        return
      }
      if (this.leadDetails?.alternate_email) {
        if (this.leadDetails?.alternate_email?.toLowerCase() == this.leadDetails?.email?.toLowerCase()) {
          this.toastr.error("Alternate email ID cannot be same as Email ID!")
          return
        }
      }
      // Handle stage-specific payloads based on stageId
      switch (this.leadDetails.current_stage.stage_id) {
        case 2: // Stage 2 - Follow Up
          if (this.originalLeadDetails.followup_reason) {
            const [reasonId, reasonName] = this.originalLeadDetails.followup_reason.split(':');
            updatePayload.followup_reason = reasonId + ':' + reasonName;
          }        // Combine date and time into a single property
          const combinedDateTime = `${moment(this.originalLeadDetails.next_followup_date).format('YYYY-MM-DD')} ${moment(this.originalLeadDetails.next_followup_time, ['h:mm A']).format('HH:mm')}`;
          const utcDateTime = moment(combinedDateTime, 'YYYY-MM-DD HH:mm').utc().format();
          updatePayload.next_followup_date = utcDateTime
          break;
        case 5: // Stage 5 - Junk
          // updatePayload.junk_reason = "1:Test"; 
          if (this.originalLeadDetails.junk_reason) {
            const [reasonId, reasonName] = this.originalLeadDetails.junk_reason.split(':');
            updatePayload.junk_reason = reasonId + ':' + reasonName;
          }
          break;
        case 7: // Stage 7 - Lost
          // updatePayload.lost_reason = "1:Test"; /
          if (this.originalLeadDetails.lost_reason) {
            const [reasonId, reasonName] = this.originalLeadDetails.lost_reason.split(':');
            updatePayload.lost_reason = reasonId + ':' + reasonName; // Adjust format as needed
          }
          break;
        default:
          break;
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.detailsPanelService.editDetails(updatePayload, this.leadDetails._id).subscribe(
        (response) => {
          if (response.body.responseCode == 200) {
            this.isEditMode = false;
            this.isFieldEdited = false;
            this.submitted = false;
            this.isLoading = new BehaviorSubject<boolean>(false);
            this.toastr.success("Lead details updated successfully!");
            this.getLeadDetails(this.leadDetails['_id'])
          } else {
            this.isLoading = new BehaviorSubject<boolean>(false);
            this.toastr.error(response.body.responseMessage);
          }
        },
        (error) => {
          this.isLoading = new BehaviorSubject<boolean>(false);

        }
      );
    }
  }

  combineDateTime(date: string, time: string): string {
    const combinedDateTime = new Date(date + 'T' + time).toISOString();
    return combinedDateTime;
  }




  formatDateForInput(date: string, format: string): string {
    if (!date) return ''; // Handle null or undefined date strings

    return moment(date).format(format); // Format date using Moment.js
  }



  isVisible = false;

  togglePanel(data: any) {
    if (data) {
      this.getLeadDetails(data['_id'])
    }
    // this.leadDetails = {...data};

    if (this.isVisible) {
      document.querySelector('.panel')?.classList.add('slide-out');
      setTimeout(() => {
        this.isVisible = false;
      }, 300);
      this.change.emit(false);
    } else {
      this.isVisible = true;
      this.change.emit(true);
    }
  }

  openDialog(): void {
    if (
      !this.leadDetails?.first_name ||
      !this.leadDetails?.product_details?.product_category_id ||
      !this.leadDetails?.product_details?.product_model_id ||
      !this.leadDetails?.product_details?.product_color_id ||
      !this.leadDetails?.product_details?.product_variant_id ||
      !this.leadDetails?.age_group_id ||
      !this.leadDetails?.current_stage?.customer_interest_id
    ) {
      this.toastr.error("Kindly update the mandatory fields by clicking on the Edit Lead button.");
    } else {
      const dialogRef = this.dialog.open(SalesManagerModalComponent, {
        data: {
          leadId: this.leadDetails.lead_id,
          // leadStage: this.leadDetails.current_stage.stage
          selectedProductCategory: this.leadDetails?.product_details?.product_category,
          selectedProductCategoryID: this.leadDetails?.product_details?.product_category_id,
          selectedProductModel: this.leadDetails?.product_details?.product_model,
          selectedProductModelID: this.leadDetails?.product_details?.product_model_id,
          selectedProductModelCode: this.leadDetails?.product_details?.product_model_code,
          selectedProductVariant: this.leadDetails?.product_details?.product_variant,
          selectedProductVariantID: this.leadDetails?.product_details?.product_variant_id,
          selectedProductVariantCode: this.leadDetails?.product_details?.product_variant_code,
          selectedProductColor: this.leadDetails?.product_details?.product_color,
          selectedProductColorID: this.leadDetails?.product_details?.product_color_id,
          selectedProductColorCode: this.leadDetails?.product_details?.product_color_code,
          selectedAgeGroupID: this.leadDetails?.age_group_id ? this.leadDetails?.age_group_id : null,
          selectedAgeGroup: this.leadDetails?.age_group ? this.leadDetails?.age_group : null
        },
        width: '550px'
      });

      dialogRef.componentInstance.successfulSubmission.subscribe(() => {
        // Call togglePanel method here
        this.togglePanel('');
      });

      dialogRef.afterClosed().subscribe(result => {
      });
    }
  }

  followupDialog(): void {
    const dialogRef = this.dialog.open(FollowUpComponent, {
      data: {
        leadId: this.leadDetails._id,
        leadStage: this.leadDetails.current_stage.stage
      },
      width: '550px'
    });

    dialogRef.componentInstance.successfulSubmission.subscribe(() => {
      // Call togglePanel method here
      this.togglePanel('');
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  lostjunkDialog(): void {
    const dialogRef = this.dialog.open(LostJunkComponent, {
      data: { leadId: this.leadDetails._id },
      width: '450px'
    });

    dialogRef.componentInstance.successfulSubmission.subscribe(() => {
      // Call togglePanel method here
      this.togglePanel('');
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  nonsalesDialog(updateFlag:any): void {
    const dialogRef = this.dialog.open(NonSalesComponent, {
      data: { leadId: this.leadDetails._id, isUpdate: updateFlag, category_id: this.leadDetails?.current_stage?.non_sales_category_id || null, category: this.leadDetails?.current_stage?.non_sales_category || null, registration_number: this.leadDetails?.registration_number || null, remarks: this.leadDetails?.current_stage?.remarks || null },
      width: '500px'
    });

    dialogRef.componentInstance.successfulSubmission.subscribe(() => {
      // Call togglePanel method here
      this.togglePanel('');
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  noresponseDialog(): void {
    const dialogRef = this.dialog.open(NoResponseComponent, {
      data: { leadId: this.leadDetails._id },
      width: '500px'
    });

    dialogRef.componentInstance.successfulSubmission.subscribe(() => {
      // Call togglePanel method here
      this.togglePanel('');
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  audioData: any = null;
  audioMimeType: any = null;
  emailID: any = null
  getLeadDetails(leadId: string) {
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.detailsPanelService.getDetails(leadId).subscribe((response: any) => {
      // Extract data from the response body
      if (response.body.responseCode == 200) {
        this.leadDetails = response.body.data.lead;
        this.emailID = this.leadDetails.email;
        this.audioData = response.body.data.audioData
        this.audioMimeType = response.body.data.audioMimeType
        this.isLoading = new BehaviorSubject<boolean>(false);
      } else {
        this.isLoading = new BehaviorSubject<boolean>(false);
      }
    }, (error) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  openHistory() {
    const dialogRef = this.dialog.open(LeadHistoryComponent, {
      width: '65%',
      height: '95vh',
      data: { leadId: this.leadDetails['_id'] }
    });
  }

  onCategoryChange(event: any) {
    const categoryId = event.target.value;
    // console.log(categoryId, 'categoryId');

    if (categoryId) {
      this.filteredProducts = this.products.filter((product: any) => product.category_id === parseInt(categoryId));
      // console.log(this.filteredProducts, 'this.filteredProducts');

    } else {
      this.filteredProducts = [];
    }
    this.productForm.patchValue({
      model: '',
      variant: '',
      color: '',
    })
    this.filteredProductsVar = []
    this.filteredProductsColor = []
  }

  onModelChange(event: any) {
    const selectedProductId = parseInt(event.target.value.split(':')[0]);
    // console.log(selectedProductId, 'selectedProductId');


    this.filteredProductsVar = this.variants.filter((variant: any) => variant.model_id === selectedProductId);

    // console.log(this.filteredProductsVar, 'filteredProductsVar');
    if (this.filteredProductsVar.length > 0) {
      // this.productForm.patchValue({
      //   variant:this.filteredProductsVar[0].id+":"+this.filteredProductsVar[0].variant,
      //   color:'',
      // })
      setTimeout(() => {
        this.productForm.patchValue({
          variant: '',
          color: '',
        })
      })
    }
    // this.onVariantChange(event)
    this.filteredProductsColor = []
  }

  onVariantChange(event: any) {
    const selectedVariantId = parseInt(event.target.value.split(':')[0]);
    console.log(selectedVariantId, 'selectedVariantId');
    this.filteredProductsColorId = this.variants.find((variant: any) => variant.id == selectedVariantId)
    console.log(this.filteredProductsColorId, 'this.filteredProductsColorId');
    const allColorIds: any = this.filteredProductsColorId?.color_id.map((id: any) => parseInt(id));


    console.log('allColorIds: ', allColorIds);
    this.filteredProductsColor = this.prodColors.filter((color: any) =>
      allColorIds.includes(color.id)
    );

    console.log(this.filteredProductsColor, 'Filtered Products Color');
    if (this.filteredProductsColor.length > 0) {
      // this.productForm.patchValue({
      //   color:this.filteredProductsColor[0].id+":"+this.filteredProductsColor[0].color,
      // })
    }
    setTimeout(() => {
      this.productForm.patchValue({
        color: '',
      })
    })
  }

  allowNumbersOnly(event: any) {
    this.sharedService.allowNumbersOnly(event);
  }

  @ViewChild('audioDialog', { static: true }) audioDialog!: TemplateRef<any>;
  dialogRef!: MatDialogRef<any>;
  openAudioDialog() {
    this.dialogRef = this.dialog.open(this.audioDialog, {
      width: '400px'
    });
  }

  closeAudio(): void {
    this.dialogRef.close();
  }

  isFieldEdited: boolean = false;
  onFieldEdit() {
    this.isFieldEdited = true;
  }
  alternateEmailError: boolean = false;
  emailErrorMessage: string = '';
  validateAlternateEmail(): void {

    const email = this.leadDetails.alternate_email;
    if (!email) {
      this.alternateEmailError = false;
      this.emailErrorMessage = '';
      return;
    }

    // Simple email regex validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) {
      this.alternateEmailError = true;
      this.emailErrorMessage = 'Enter a valid alternate email.';
    } else {
      this.alternateEmailError = false;
      this.emailErrorMessage = '';
    }
  }

  emailError: boolean = false;
  validateEmail(): void {

    const email = this.leadDetails.email;
    if (!email) {
      this.emailError = false;
      return;
    }

    // Simple email regex validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) {
      this.emailError = true;
    } else {
      this.emailError = false;
    }
  }

  mobileNumberError: boolean = false;
  mobileErrorMessage: string = '';
  validateMobileNumber(): void {

    const mobileNumber = this.leadDetails.alternate_mobile;
    if (!mobileNumber) {
      this.mobileNumberError = false;
      this.mobileErrorMessage = '';
      return;
    }
    // Simple mobile number validation for 10 digits
    const mobileNumberRegex = /^[6-9][0-9]{9}$/;

    if (!mobileNumberRegex.test(mobileNumber)) {
      this.mobileNumberError = true;
      this.mobileErrorMessage = 'Enter a valid 10-digit mobile number.';
    } else {
      this.mobileNumberError = false;
      this.mobileErrorMessage = '';
    }
  }
}